import React from 'react';
import { useTranslation } from 'react-i18next';

import { Dropdown } from 'primereact/dropdown';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { selectEmployee } from '../actions';
import { updateEmployee, refreshReferential } from '../../app/updateApp';
import { faUserHardHat } from '@fortawesome/pro-regular-svg-icons';

const DropDownEmployee = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const authState = useSelector(state => state.auth);
    const employeeState = useSelector(state => state.employees);
    const userState = useSelector(state => state.users);
    const currentUser = userState.list.find(user => user.id === authState.user_id);

    const employeeList = currentUser.is_multi_employee === 1 ? employeeState.all : employeeState.team;

    return <div className="userSelection">
        <div style={{ display: 'flex', margin: '0 0px', alignItems: 'center', flexDirection: 'row'}}>
            <FontAwesomeIcon style={{ color: '#fbc601', fontSize: '42px', marginRight: '14px' }} icon={faUserHardHat} />
            <Dropdown
                scrollHeight="250px"
                className="p-shadow-2"
                emptyMessage={t('app:no_result_found')}
                autoFocus
                value={employeeState.selectedEmployee}
                options={employeeList.map(employee => {
                    return {
                        value: employee.id,
                        label: employee.lastname + ' ' + employee.firstname
                    };
                })}
                onChange={(e) => { dispatch(selectEmployee(e.target.value)); refreshReferential().then(() => updateEmployee(e.target.value)); }}
                filter
                placeholder={t('app:no_selected_employee')}
            />
        </div>
    </div>;

};

export default DropDownEmployee;